/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S5_HeadingInputs */

const tr_iade_iptal_s5_heading = /** @type {(inputs: Iade_Iptal_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. İade Koşulları (3 Gün Kuralı)`)
};

const en_iade_iptal_s5_heading = /** @type {(inputs: Iade_Iptal_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Refund Conditions (3-Day Rule)`)
};

const de_iade_iptal_s5_heading = /** @type {(inputs: Iade_Iptal_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Erstattungsbedingungen (3-Tage-Regel)`)
};

const ru_iade_iptal_s5_heading = /** @type {(inputs: Iade_Iptal_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Условия возврата (правило 3 дней)`)
};

/**
* | output |
* | --- |
* | "5. Refund Conditions (3-Day Rule)" |
*
* @param {Iade_Iptal_S5_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s5_heading = /** @type {((inputs?: Iade_Iptal_S5_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S5_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s5_heading(inputs)
	if (locale === "de") return de_iade_iptal_s5_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s5_heading(inputs)
	return tr_iade_iptal_s5_heading(inputs)
});